var map = {
	"./AssignmentFlag.svg": [
		40162,
		162
	],
	"./Basemap.svg": [
		46982,
		6982
	],
	"./ChevronDown.svg": [
		5349,
		5349
	],
	"./ChevronLeft.svg": [
		50914,
		914
	],
	"./ChevronRight.svg": [
		94349,
		4349
	],
	"./ChevronRightBrandGreen.svg": [
		70773,
		773
	],
	"./ChevronRightSmall.svg": [
		31761,
		1761
	],
	"./Close.svg": [
		88339,
		8339
	],
	"./CloseLg.svg": [
		60295,
		295
	],
	"./CloseLgWithPadding.svg": [
		20809,
		809
	],
	"./Deforestation.svg": [
		95664,
		5664
	],
	"./Delete.svg": [
		15638,
		5638
	],
	"./DrawPolygon.svg": [
		85802,
		3366
	],
	"./Edit.svg": [
		73828,
		3828
	],
	"./EditPolygon.svg": [
		12420,
		2420
	],
	"./EmptyAreas.svg": [
		84598,
		4598
	],
	"./EmptyReports.svg": [
		94690,
		4690
	],
	"./EmptyTeams.svg": [
		33391,
		3391
	],
	"./Error.svg": [
		22723,
		2723
	],
	"./ExternalLink.svg": [
		6447,
		6447
	],
	"./FactCheck.svg": [
		48971,
		8971
	],
	"./GreenPlus.svg": [
		34645,
		4645
	],
	"./Help.svg": [
		32408,
		2408
	],
	"./Info.svg": [
		94991,
		4991
	],
	"./InfoBubble.svg": [
		57419,
		7419
	],
	"./LoginIcon.svg": [
		55229,
		5229
	],
	"./MapKey.svg": [
		83762,
		3762
	],
	"./MapSlider.svg": [
		42553,
		2553
	],
	"./Minus.svg": [
		70157,
		157
	],
	"./People.svg": [
		62164,
		2164
	],
	"./Plus.svg": [
		51322,
		1322
	],
	"./PlusForButton.svg": [
		53619,
		3619
	],
	"./PlusWhite.svg": [
		67534,
		7534
	],
	"./Profile.svg": [
		19747,
		9747
	],
	"./RadioOff.svg": [
		3843,
		3843
	],
	"./RadioOn.svg": [
		76684,
		6684
	],
	"./Reports.svg": [
		78726,
		8726
	],
	"./Routes.svg": [
		3443,
		3443
	],
	"./Search.svg": [
		4716,
		4716
	],
	"./area.svg": [
		80134,
		134
	],
	"./assignmentIcons/areas.svg": [
		67545,
		7545
	],
	"./assignmentIcons/assignment-type.svg": [
		77905,
		7905
	],
	"./assignmentIcons/creation.svg": [
		11802,
		1802
	],
	"./assignmentIcons/monitor.svg": [
		83555,
		3555
	],
	"./assignmentIcons/notes.svg": [
		73063,
		3063
	],
	"./assignmentIcons/status.svg": [
		38879,
		8879
	],
	"./assignmentIcons/templates.svg": [
		72689,
		2689
	],
	"./check-doc.svg": [
		88879,
		5488
	],
	"./check-green.svg": [
		72028,
		2028
	],
	"./check.svg": [
		85384,
		5384
	],
	"./checkbox-off.svg": [
		65732,
		5732
	],
	"./checkbox-on.svg": [
		70482,
		482
	],
	"./chevron-left.svg": [
		46119,
		6119
	],
	"./delete-round.svg": [
		26854,
		6854
	],
	"./download.svg": [
		62636,
		2636
	],
	"./facebook-logo.svg": [
		98715,
		8715
	],
	"./flag-white.svg": [
		57561,
		7561
	],
	"./flag.svg": [
		32838,
		2838
	],
	"./footprint.svg": [
		88508,
		8508
	],
	"./google-logo.svg": [
		38393,
		8393
	],
	"./kebab-hover.svg": [
		1983,
		1983
	],
	"./kebab.svg": [
		58694,
		8694
	],
	"./link.svg": [
		98371,
		8371
	],
	"./logo.svg": [
		74829,
		4829
	],
	"./mapCardIcons/Areas.svg": [
		71149,
		1149
	],
	"./mapCardIcons/Reports.svg": [
		50903,
		903
	],
	"./mapKeyIcons/Alerts.svg": [
		44922,
		4922
	],
	"./mapKeyIcons/AssignmentsAssigned.svg": [
		8444,
		8444
	],
	"./mapKeyIcons/AssignmentsCreated.svg": [
		8667,
		8667
	],
	"./mapKeyIcons/ImportedReports.svg": [
		93150,
		3150
	],
	"./mapKeyIcons/MyReports.svg": [
		91076,
		1076
	],
	"./mapKeyIcons/VIIRSAlerts.svg": [
		67034,
		7034
	],
	"./mapKeyIcons/VIIRSReports.svg": [
		42728,
		2728
	],
	"./oval.svg": [
		11638,
		1638
	],
	"./target.svg": [
		38614,
		8614
	],
	"./translate.svg": [
		1799,
		1799
	],
	"./white-foot.svg": [
		83845,
		3845
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87328;
module.exports = webpackAsyncContext;